<template>
    <div class="container-md p-0">
       <div class="d-flex justify-content-between px-5 py-2 mx-auto d-md-none" style="max-width: 400px;">
          <div class="info-app">
            <router-link :to="{name: 'presentation'}">
              <IconInfo />
              <br>
              <span class="text-uppercase">{{$t("layout_info")}}</span>
            </router-link>
          </div>
          <div class="info-app">
            <router-link :to="{name: 'orari'}">
              <IconTime />
              <br>
              <span class="text-uppercase">{{$t("layout_orari")}}</span>
            </router-link>
            </div>
          <div class="info-app">
            <router-link :to="{name: 'news.list'}">
              <IconNews />
              <br>
              <span class="text-uppercase">{{$t("layout_news")}}</span>
            </router-link>
          </div>
          <div class="info-app">
            <router-link :to="{name: 'notifiche'}">
              <IconNotify />
              <br>
              <span class="text-uppercase">{{$t("layout_notifiche")}}</span>
            </router-link>
          </div>
        </div>
       <router-link :to="{name:'rooms'}">
          <div class="header header-home text-left d-flex justify-content-between">
            <div>
              <h1 class="f1"><b>{{this.locale.nome_locale}}</b></h1>
              <div class="f14" v-if="this.service_point">{{this.service_point.traduzione.nome}}</div>
            </div>
            <div class="d-flex align-items-center">
              <span class="d-none d-md-block pr-2">{{ $t('scegli_locale') }}</span> <i class="pi pi-map-marker"></i></div>
          </div>
        </router-link>

       <div class="wrapper wrapper-home mt-0">
          <div class="nowopen d-flex justify-content-between align-items-center">
            <div>
              <i class="pi pi-circle-fill mr-1 f12" :class="currentOpeningStatus.isOpen ? 'ora-aperto' : 'ora-chiuso'"></i>
              {{ currentOpeningStatus.isOpen ? 'ORA APERTO' : 'ORA CHIUSO' }}
            </div>
            <div>{{ currentOpeningStatus.hours }}</div>
          </div>

        <!-- visua solo su mobile app fino a tablet verticale -->
          <div class="d-md-none">

            <!-- ORIDNA -->
            <router-link :to="{name:'orders'}">
              <div class="ordina-home-app d-flex flex-column text-uppercase">
                <span class="material-symbols-outlined icone50">menu_book</span>
                {{ $t('ristorante_ordina_btn') }}
              </div>
            </router-link>


            <!-- ACCEDI  -->
              <router-link to="utente/login" v-if="!this.userAuthenticated">
                <div class="accedi-home-app d-flex justify-content-center align-items-center text-uppercase">
                    <i class="pi pi-lock f16 mr-2"></i> {{ $t('account.accedi') }}
                </div>
              </router-link>

            <!-- STORICO -MESSAGGI -->
              <div class="accedi-home-app d-flex justify-content-center align-items-center text-uppercase" v-if="this.userAuthenticated">
                  <router-link to="ordine/storico" class="w-100 text-center">
                      <i class="pi pi-wallet f16 mr-2"></i> {{ $t('account.storico_ordini') }}
                  </router-link>
                  <div>|</div>
                <router-link to="messaggistica" class="w-100 text-center text-uppercase d-flex justify-content-center align-items-center">
                    <i class="pi pi-comments f16 mr-2"></i>
                    <span class="badge badge-info mr-2" v-if="this.unread_messages_counter">
                        {{ this.unread_messages_counter }}
                      </span>
                    {{ $t('messaggi') }}
                </router-link>
              </div>
          </div>

          <!-- visua su desktop -->
          <div class="text-center d-none d-md-block bg-white">
                <!-- ordini + prenotazioni tavoli -->
                <div class="row">
                    <div class="col-md-6 sezione" :class="{'col-md-12': !this.enable_reservations}">
                        <!-- <img :src="`/img/be/${this.targa}/menu.png`" class="img-fluid img-center"> -->
                      <IconOrderHome width="150" />
                        <p>{{$t('ristorante_consulta')}}</p>
                        <router-link :to="{name:'orders'}" class="btn btn-menu">
                            {{$t('ristorante_ordina_btn')}}
                        </router-link>
                    </div>
                    <div class="col-md-6 sezione" v-if="this.enable_reservations">
                      <IconTableHome width="150" />
                        <p>{{$t('ristorante_prenota')}}</p>
                        <router-link :to="{name:'reservations.reserve'}" class="btn btn-menu" v-if="!this.locale.prenota_tavolo_external_url">
                            {{$t('ristorante_prenota_btn')}}
                        </router-link>
                        <a target="_blank" :href="`${this.locale.prenota_tavolo_external_url}`" class="btn btn-menu" v-if="this.locale.prenota_tavolo_external_url">{{$t('ristorante_prenota_btn')}}</a>
                    </div>
                </div>
          </div>

          <!-- BANNER PROMOZIONALI -->
          <div class="banner bg-gray pt-4 px-4 pb-md-4" v-if="this.banners.length">
            <swiper
                :key="`home-banners-${this.banners.length}`"
                class="swiper swiper-banner d-flex align-self-start"
                :options="bannerSwiperOptions"
            >
              <swiper-slide
                  v-for="banner in this.banners"
                  :key="`banner-${banner.id}`"
                  class="slide slide-banner"
                  :style="getBannerStyle(banner)"
                  @click.native="onBannerPress(banner)"
              >
                <div class="tipo">{{ getBannerTypeName(banner) }}</div>

                <template v-if="banner.tipo === 'SCONTO'">
                  <div class="sconto">{{ getBannerDiscountValue(banner) }}</div>
                  <div class="sconto-descrizione">
                    <div>CODICE: <b>{{ banner.bannerable.nome }}</b></div>
                    <span class="f12">{{ getCouponValidity(banner) }}</span>
                  </div>
                </template>

                <template v-else-if="banner.tipo === 'NOVITA'">
                  <div class="novita-descrizione" v-html="getBannerNewsText(banner)"></div>
                </template>
              </swiper-slide>
            </swiper>
          </div>

          <!-- APP LINK PRENOTA TAVOLO E CODICI SCONTO / FIDELITY -->
          <div class="d-md-none bg-gray px-4 pt-4 pb-2"
               v-if="this.enable_reservations || this.enable_codici_sconto || this.enable_fidelity_card">
            <div v-if="this.enable_reservations">
              <router-link :to="{name:'reservations.reserve'}" v-if="!this.locale.prenota_tavolo_external_url">
                <div class="prenota-home-app">
                  <div class="d-flex justify-content-between align-items-center text-uppercase">
                    {{$t('prenotazione_tavolo.submit_btn')}}
                    <span class="material-symbols-outlined icone40">calendar_meal</span>
                  </div>
                </div>
              </router-link>
              <a target="_blank" :href="`${this.locale.prenota_tavolo_external_url}`" v-if="this.locale.prenota_tavolo_external_url">
                <div class="prenota-home-app">
                  <div class="d-flex justify-content-between align-items-center text-uppercase">
                    {{$t('prenotazione_tavolo.submit_btn')}}
                    <span class="material-symbols-outlined icone40">calendar_meal</span>
                  </div>
                </div>
              </a>
            </div>

            <!-- CODICI E FIDELITY -->
            <div class="row pt-3">
              <div class="col mb-3" v-if="this.enable_codici_sconto">
                <router-link to="/ordine/sconti">
                  <div class="sconto-home-app d-flex justify-content-between align-items-center text-uppercase">
                    <div>{{$t('codici_sconto')}}</div>
                    <span class="material-symbols-outlined icone40">percent_discount</span>
                  </div>
                </router-link>
              </div>
              <div class="col mb-3" v-if="this.enable_fidelity_card">
                <router-link to="fidelity">
                  <div class="fidelity-home-app d-flex justify-content-between align-items-center text-uppercase">
                    <div class="pr-2">{{$t('fidelity')}} {{$t('card')}}</div>
                    <span class="material-symbols-outlined icone40">redeem</span>
                  </div>
                </router-link>
              </div>
            </div>
          </div>

          <!-- FIDELITY CARD WEBAPP -->
          <div class="content sezione bg-gray d-none d-md-block pb-4 px-4 pt-4" :class="{'pt-md-0': this.banners.length}"
               v-if="this.userAuthenticated && this.enable_fidelity_card && this.fidelity_card_promozione && this.fidelity_card_promozione.promozione">
            <div class="card" style="border-radius: 20px; border: none;">
              <div class="card-body">
                <h4 class="card-title color">
                  <router-link :to="{name:'fidelity'}" class="a5 d-flex align-items-center justify-content-center">
                    <span class="material-symbols-outlined icone50 mr-2">redeem</span>
                    <div>{{$t('layout_fidelity_card')}}</div>
                  </router-link>
                </h4>
                <div class="text-center">
                  <!-- questa è la riga che va messa se non ho ancora punti nella fidelity <span class="text-muted">
                      Non hai ancora accumulato punti nella tua fidelity card.
                      <br>Comincia adesso, fai un ordine per ricevere i nostri premi.</span> -->
                  <span class="text-muted">{{$t("fidelity_card_ad_home_c1")}}</span>
                  <div class="f30 text-uppercase py-3"><b>
                    <i class="ti-arrow-up text-success"></i>
                    {{this.fidelity_card_promozione.punteggio_personale}} {{$t("punti")}}</b>
                  </div>
                </div>
                <div class="progress">
                  <div class="progress-bar progress-bar-striped" role="progressbar"
                       aria-valuenow="25"
                       :style="{width: (this.fidelity_card_percentage)+'%' }"
                       aria-valuemin="0" aria-valuemax="100">{{this.fidelity_card_percentage}}%</div>
                </div>
              </div>
            </div>
          </div>

          <div class="content sezione d-none d-md-block p-4" v-if="(this.locale_photos.length) || this.getLocaleDescription()">
              <div class="row">
                  <div class="text-justify"
                       :class="{'col-md-6': this.locale_photos.length, 'col-md-12': !this.locale_photos.length}">
                    <p class="f2 color text-uppercase">{{$t('ristorante_presentiamo_titolo')}}...</p>
                    <p v-html="this.getLocaleDescription(295)"></p>
                      <router-link :to="{name:'presentation'}" class="btn btn-primary btn-sm">
                          {{$t('ristorante_continua_lettura_btn')}} »
                      </router-link>
                  </div>
                  <div class="col-md-6" v-if="this.locale_photos.length">
                      <img :src="this.locale_image" class="img-fluid">
                  </div>
              </div>
          </div>

            <div class="content sezione d-none d-md-block p-4 border-top" v-if="this.news.length">
                <p class="f2 color text-center text-uppercase">{{$t('ristorante_novita_titolo')}}</p>
                <div class="row" v-for="notice in this.news">
                    <div class="col-md-4 col-lg-3">
                        <img :src="getNewsImage(notice)" class="img-fluid img-center">
                    </div>
                    <div class="col-md-8 col-lg-9">
                        <p class="gray d-flex align-items-center mb-2 f13"><span class="material-symbols-outlined mr-2 f18">calendar_month</span>
                            <i>
                                {{moment(notice.created_at).locale(language).format('dddd DD MMMM YYYY')}}
                            </i>
                        </p>
                        <p class="text-uppercase mb-0">{{notice.traduzione.titolo}}</p>
                        <p class="mb-3" v-html="displayNewsText(notice)"></p>
                        <router-link class="btn btn-primary btn-sm"
                                     :to="{name: 'news.list'}">
                            {{$t('ristorante_novita-vedi_btn')}}
                        </router-link>
                    </div>
                </div>
            </div>

          <div class="content sezione bg-gray d-none d-md-block">
                <p class="f2 color text-center text-uppercase">{{$t('ristorante_orario_titolo')}}</p>
                <table class="table table-borderless table-sm" style="max-width:350px; margin:0 auto;">
                    <tbody>
                    <tr v-for="(opening, i) in this.opening_hours"
                        :key="i">
                        <td width="70">
                            <b>
                                {{
                                    moment((i >= 6 ? 0 : (i + 1)), "d").locale(language)
                                        .format("ddd").toUpperCase()
                                }}
                            </b>
                        </td>
                        <td :width="opening.length > 1 ? 140:280" :class="{'red': opening[0] === 'chiuso'}">
                            {{opening[0] === 'chiuso' ? $t('chiuso') : opening[0]}}
                        </td>
                        <td v-if="opening.length > 1" width="140" :class="{'red': opening[1] === 'chiuso'}">
                            {{opening[1] === 'chiuso' ? $t('chiuso') : opening[1]}}
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br>

                <!-- CHIUSURE -->
                <div v-if="this.configurazione_chiusure.length">
                    <div class="f1 text-center red">{{$t('ristorante_chiusure_title')}}:</div>
                    <p class="text-center m-0" v-for="closure in this.configurazione_chiusure">
                        <span class="text-capitalize">{{$t('dal')}}</span>
                        {{moment(closure.dal_giorno).format("DD/MM/YYYY")}} {{$t('al')}}
                        {{moment(closure.al_giorno).format("DD/MM/YYYY")}} -
                        {{closure.traduzione_ll ? closure.traduzione_ll.messaggio : null}}
                    </p>
                </div>
            </div>

            <div class="content sezione pb-md-3">
                <p class="f2 color text-center text-uppercase d-none d-md-block">{{$t('ristorante_contatti_titolo')}}</p>
                <p class="text-center mb-0 mb-md-2"><b class="f4">{{this.locale.nome_locale}}</b><br>
                    {{this.locale.indirizzo}}, {{this.locale.civico}}<br>
                    {{this.locale.cap}} - {{this.locale.citta}} ({{this.locale.provincia}})<br>
                    <i class="fa fa-phone fa-flip-horizontal mr-1"></i>
                    <a :href="'tel:'+this.locale.telefono" class="a2">
                        {{this.locale.telefono}}
                    </a> &nbsp;
                    <i class="fa fa-envelope mr-1"></i>{{this.locale.email}}
                </p>
                <p class="text-center mb-0 pb-3 d-none d-md-block">{{this.locale.ragione_sociale}} - {{$t("piva")}} {{this.locale.piva}}</p>
            </div>
            <iframe v-if="this.locale.latitudine && this.locale.longitudine" class="w-100 mappa-home" height="200" frameborder="0"
                    scrolling="no" marginheight="0" marginwidth="0"
                    :src="`https://maps.google.com/maps?q=${this.locale_address}&t=&z=14&ie=UTF8&iwloc=&output=embed`"></iframe>
        </div>
    </div>
</template>

<script>
import {Swiper, SwiperSlide} from "vue-awesome-swiper";
import {mapState, mapGetters, mapActions} from 'vuex';
import {getImage} from "../api/core";
import {getFidelityCard, getMixedInfo} from "../api/restaurant";
import IconInfo from "../components/IconInfo.vue";
import IconTime from "../components/IconTime.vue";
import IconNews from "../components/IconNews.vue";
import IconNotify from "../components/IconNotify.vue";
import IconOrderHome from "../components/IconOrderHome.vue";
import IconTableHome from "../components/IconTableHome.vue";

export default {
  components: {IconTableHome, IconOrderHome, IconNotify, IconNews, IconTime, IconInfo, Swiper, SwiperSlide},
    data() {
        return {
            bannerSwiperOptions: {
                slidesPerView: 1.2,
                spaceBetween: 12,
                loop: false,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: true
                },
                breakpoints: {
                    768: {
                        slidesPerView: 3.2,
                        spaceBetween: 16
                    }
                }
            },
            banners: [],
            fidelity_card_promozione: null,
            configurazione_chiusure: [],
            news: [],
            info_locale: []
        }
    },
    created() {
        this.fetchInfo();
    },
    computed: {
        locale_photos: function () {
            if (this.info_locale && this.info_locale.foto) {
                return this.info_locale.foto;
            }

            return [];
        },
        locale_image: function () {
            try {
                const code = this.info_locale.foto[0].codice;

                return getImage(this.language, this.id_ristorante, code);
            } catch (e) {
                return null;
            }
        },
        fidelity_card_percentage: function () {
            try {
                return parseInt(this.fidelity_card_promozione.punteggio_personale / this.fidelity_card_promozione.punteggio_massimo * 100);
            } catch (e) {
                return 0;
            }
        },
        service_point: function () {
            if (this.f_modalita_fiera) {
                return this.punti_di_servizio.find((point) => {
                    return point.id === this.id_punto_di_servizio
                });
            }

            return null;
        },
        currentOpeningStatus: function () {
            try{
                // crediti: Claude (messo dentro un try catch perchè mi fido 0 di sto codice)
                const now = new Date();
                const currentDay = now.getDay() === 0 ? 7 : now.getDay(); // 1=Lunedì, 7=Domenica
                const currentTime = now.getHours() * 60 + now.getMinutes(); // minuti dall'inizio del giorno

                // Trova gli orari di oggi
                const todaySchedules = this.locale.orari_ristorante.filter(orario => {
                    return parseInt(orario.giorno) === currentDay && orario.tipo === 'RISTORANTE';
                });

                if (!todaySchedules.length) {
                    return {
                        isOpen: false,
                        hours: this.$t('chiuso')
                    };
                }

                let isOpen = false;
                let hours = [];

                todaySchedules.forEach(schedule => {
                    if (schedule.chiuso || !schedule.dalle_ore || !schedule.alle_ore) {
                        return;
                    }

                    // Converti orari in minuti
                    const [dalleh, dallem] = schedule.dalle_ore.split(':').map(Number);
                    const [alleh, allem] = schedule.alle_ore.split(':').map(Number);
                    const dalleTime = dalleh * 60 + dallem;
                    const alleTime = alleh * 60 + allem;

                    // Aggiungi fascia oraria alla lista
                    hours.push(`${schedule.dalle_ore.substring(0, 5)} - ${schedule.alle_ore.substring(0, 5)}`);

                    // Controlla se siamo dentro questa fascia
                    if (alleTime <= dalleTime) {
                        // es. 19:30 - 00:00, il confronto sotto sminchia perchè alleTime diventa 0
                        if (currentTime >= dalleTime || currentTime <= alleTime) {
                            isOpen = true;
                        }
                    } else {
                        if (currentTime >= dalleTime && currentTime <= alleTime) {
                            isOpen = true;
                        }
                    }
                });

                return {
                    isOpen: isOpen,
                    hours: hours.length > 0 ? hours.join(' / ') : this.$t('chiuso')
                };
            }catch (e) {
                return {
                    isOpen: true,
                    hours: "N/A"
                };
            }
        },
        ...mapGetters('restaurant', {
            enable_reservations: 'enableReservations',
            enable_fidelity_card: 'enableFidelityCard',
            enable_codici_sconto: 'enableCoupons',
            enableMessaging: 'enableMessaging',
            locale_currency: 'localeCurrency',
            opening_hours: 'openingHours',
            locale_address: 'localeAddress',
            getLocaleImageCode: 'localeImageCode',
            getLocaleDescription: 'localeDescription',
        }),
        ...mapGetters('auth', {
            userAuthenticated: 'authenticated'
        }),
        ...mapGetters('chat', {
            unread_messages_counter: 'counter'
        }),
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapState('restaurant', {
            targa: state => state.targa,
            locale: state => state.locale,
            id_ristorante: state => state.id,
            punti_di_servizio: state => state.punti_di_servizio,
            f_modalita_fiera: state => state.f_modalita_fiera
        }),
        ...mapState('auth', {
            user: state => state
        }),
        ...mapState('global', {
            loading_visible: state => state.loading_visible
        }),
        ...mapState('order', {
            id_punto_di_servizio: state => state.id_punto_di_servizio
        })
    },
    watch: {
        language: function () {
            this.fetchInfo();
        },
        userAuthenticated: function () {
            this.fetchInfo();
        }
    },
    methods: {
        fetchInfo: function () {
            this.showLoading(true);
            axios.all([
                getMixedInfo(this.language, {
                    id_ristorante: this.id_ristorante,
                    id_locale: this.locale.id,
                    configurazione_chiusure: true,
                    news: true,
                    news_limit: 1,
                    banners: true,
                    info_locale: true
                }),
                getFidelityCard(this.language, {
                    id_ristorante: this.id_ristorante,
                    id_locale: this.locale.id,
                    email: this.user.email,
                    api_key: this.user.api_key
                })
            ]).then(axios.spread((...responses) => {
                // use/access the results
                const responseMixed = responses[0];
                const responseFidelity = responses[1];

                this.configurazione_chiusure = responseMixed.configurazione_chiusure;
                this.news = responseMixed.news;
                this.info_locale = responseMixed.info_locale;
                this.banners = responseMixed.banners ? responseMixed.banners : [];
                this.fidelity_card_promozione = responseFidelity;

            })).catch(messages => {
                // react on errors.
                alert(messages.join("\n"));
            }).finally(() => {
                if (this.loading_visible) {
                    this.showLoading(false);
                }
            });
        },
        getNewsImage: function (news) {
            return getImage(this.language, this.id_ristorante, news.foto_codice);
        },
        getBannerStyle: function (banner) {
            const imageUrl = this.getBannerImage(banner);

            return {
                backgroundImage: imageUrl ? `url('${imageUrl}')` : 'none',
                backgroundColor: 'transparent',
                opacity: banner.disabled ? 0.6 : 1,
                cursor: banner.disabled ? 'not-allowed' : 'pointer'
            };
        },
        getBannerImage: function (banner) {
            if (banner && banner.foto_codice) {
                return getImage(this.language, this.id_ristorante, banner.foto_codice);
            }

            if (banner && banner.fallback_img_url) {
                return banner.fallback_img_url;
            }

            return null;
        },
        getBannerTypeName: function (banner) {
            if (!banner) {
                return 'N/A';
            }

            switch (banner.tipo) {
                case "SCONTO":
                    return this.$t("sconto");
                case "NOVITA":
                    return this.$t("layout_news");
                default:
                    return "N/A";
            }
        },
        getBannerDiscountValue: function (banner) {
            if (!banner || !banner.bannerable) {
                return "";
            }

            const suffix = banner.bannerable.tipo === "PERCENTUALE" ? "%" : (this.locale_currency ? this.locale_currency : "");
            return `-${banner.bannerable.valore}${suffix}`;
        },
        getCouponValidity: function (banner) {
            if (!banner || !banner.bannerable) {
                return "";
            }

            const dal = banner.bannerable.dal;
            const al = banner.bannerable.al;

            if (dal && al) {
                return `Dal ${this.moment(dal).format("DD/MM")} ${this.$t("al")} ${this.moment(al).format("DD/MM")}`;
            }

            if (dal) {
                return `Dal ${this.moment(dal).format("DD/MM")}`;
            }

            if (al) {
                return `Fino al ${this.moment(al).format("DD/MM")}`;
            }

            return "";
        },
        getBannerNewsText: function (banner) {
            if (banner && banner.traduzione_ll && banner.traduzione_ll.testo) {
                return banner.traduzione_ll.testo.replace(/\n/g, "<br>");
            }

            return "";
        },
        onBannerPress: function (banner) {
            if (!banner || banner.disabled) {
                return;
            }

            switch (banner.tipo) {
                case "SCONTO":
                    this.$router.push({name: "orders.discounts"}).catch(() => {});
                    break;
                case "NOVITA":
                    if (banner.id_tipo) {
                        this.$router.push({name: "news.details", params: {id: banner.id_tipo}}).catch(() => {});
                    } else {
                        this.$router.push({name: "news.list"}).catch(() => {});
                    }
                    break;
                default:
                    break;
            }
        },
        displayNewsText: function (news) {
            return news.traduzione.testo > 200 ?
                news.traduzione.testo.substr(0, 200) + ' ... ' : news.traduzione.testo
        },
        ...mapActions('global', [
            'showLoading'
        ])
    }
}
</script>
